/** Remembers the last model an admin explicitly picked, so new conversations default to it
 *  instead of resetting to the platform default every time. Scoped per-user since the same
 *  browser can have multiple admin sessions (see AuthContext's multi-session support). */
function storageKey(userId: string): string {
  return `assistant:lastModelId:${userId}`;
}

export function getLastModelId(userId: string | undefined): string | undefined {
  if (!userId) return undefined;
  return localStorage.getItem(storageKey(userId)) ?? undefined;
}

export function setLastModelId(userId: string | undefined, modelId: string): void {
  if (!userId) return;
  localStorage.setItem(storageKey(userId), modelId);
}
